import CustomPrintGenericTemplate from './CustomPrintGenericTemplate';

export default CustomPrintGenericTemplate;
